




















import { Component, Prop, Vue } from 'vue-property-decorator'

enum MessageType {
    QUESTION = 'question',
    ANSWER = 'answer',
}

@Component
export default class Message extends Vue {
    @Prop({default: MessageType.QUESTION}) type!: MessageType
    @Prop({type: Boolean, default: false}) typing!: boolean
    @Prop({type: Boolean, default: false}) avatar!: boolean

    get classes() {
        return {
            'message-container--question': this.type === MessageType.QUESTION,
            'message-container--answer': this.type === MessageType.ANSWER,
        }
    }

    get avatarType(): string {
        const types: string[] = ['brunette-waiting1', 'blond-waiting1', 'sylvana-waiting1']

        return types[this.$root.$currentCompany.widgetAvatarStyle]
    }

    get avatarColor(): string {
        return this.$root.$currentCompany.widgetAvatarCircle
    }
}
